import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const articles = allArticles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            最新资讯
          </h2>
          <Link to="/category/all" className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap flex items-center gap-1">
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-100 rounded-lg border border-background-200 overflow-hidden hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden bg-background-200">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 桔子视频资讯`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded text-xs bg-accent-500/15 text-accent-400">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime}阅读</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-500"></span>
                  <span>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}